import { FormControl } from "@mui/material";
import Box from "@mui/material/Box";
import { styled } from "@mui/material/styles";

export const Shell = styled(Box, {
  label: "admin-layout--shell"
})(({ theme }) => ({
  display: "flex",
  minHeight: "100vh",
  backgroundColor: "#f2f4f3",
  [theme.breakpoints.down("sm")]: {
    flexDirection: "column"
  }
}));

export const Sidebar = styled(Box, {
  label: "admin-layout--sidebar"
})(({ theme }) => ({
  display: "flex",
  flex: "0 0 244px",
  flexDirection: "column",
  minHeight: "100vh",
  backgroundColor: "#fff",
  borderRight: "1px solid #e2e5e3",
  [theme.breakpoints.down("sm")]: {
    flex: "none",
    minHeight: 0,
    borderRight: 0,
    borderBottom: "1px solid #e2e5e3"
  }
}));

export const Workspace = styled(Box, {
  label: "admin-layout--workspace"
})(({ theme }) => ({
  display: "flex",
  flex: 1,
  flexDirection: "column",
  minWidth: 0,
  minHeight: "100vh",
  [theme.breakpoints.down("sm")]: {
    minHeight: 0
  }
}));

/**
 * Styled admin content wrapper component
 */
export const ContentWrapper = styled(Box, {
  label: "admin-layout--content-wrapper"
})(({ theme }) => ({
  flex: 1,
  width: "100%",
  display: "flex",
  padding: "26px 28px 40px",
  overflow: "auto",
  background: "#f2f4f3",
  [theme.breakpoints.down("sm")]: {
    padding: theme.spacing(2)
  }
}));

/**
 * Styled form control component
 */
export const FormFilterWrapper = styled(FormControl, {
  label: "admin-layout--form-filter-wrapper"
})(({ theme }) => ({
  display: "flex",
  flex: "1 1 540px",
  flexDirection: "row",
  flexWrap: "wrap",
  gap: theme.spacing(1),
  minWidth: 0,
  "& .MuiTextField-root": {
    flex: "1 1 260px",
    maxWidth: 340
  },
  "& .MuiInputBase-root": {
    backgroundColor: "#fff",
    fontSize: 14
  }
}));

/**
 * Styled admin content component
 */
export const Content = styled(Box, {
  label: "admin-layout--content"
})(() => ({
  display: "flex",
  flexDirection: "column",
  flex: 1,
  width: "100%",
  minWidth: 0
}));